<template>
  <v-card-actions class="pa-0">
    <v-spacer></v-spacer>
    <v-tooltip bottom>
      <v-btn slot="activator" icon flat small @click="goDeuda" class="pa-0 ma-0 mt-1" :disabled="!item.canView">
        <v-icon color="primary">keyboard_arrow_right</v-icon>
      </v-btn>
        <span v-if="item.canView">Ver deuda</span>
        <span v-else>La deuda esta siendo corregida por LPF</span>
    </v-tooltip>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goDeuda () {
      this.$router.push({ name: 'detalleDeuda', params: { id: this.item.pk } })
    }
  }
}
</script>
